import { awaitPriorsLoaded, getPriors, logDebug, recordSuccess } from "@version.compare/bandit";
import { getSiteId } from "./siteid";

// ----------------------
// SPA LOGIC: track location changes
// ----------------------

const dispatchLocationChange = () => window.dispatchEvent(new Event("vcLocationChange"));

// Monkey-patch history.pushState
const originalPushState = history.pushState;
history.pushState = function (...args) {
  const result = originalPushState.apply(history, args);
  dispatchLocationChange();
  return result;
};

// Monkey-patch history.replaceState
const originalReplaceState = history.replaceState;
history.replaceState = function (...args) {
  const result = originalReplaceState.apply(history, args);
  dispatchLocationChange();
  return result;
};

// Listen for popstate events (back/forward navigation)
window.addEventListener("popstate", dispatchLocationChange);


// ----------------------
// General logic
// ----------------------

function potentiallyTrackSuccess(siteId: string): void {
  const currentUrl = new URL(window.location.href);
  const state = getPriors(siteId);
  Object.entries(state).forEach(([hashedExperimentId, { paths }]) => {
    if (paths.some((path) => path === currentUrl.pathname)) {
      logDebug(`Tracking success for path ${currentUrl.pathname} for experiment ${hashedExperimentId}`);
      recordSuccess(siteId, hashedExperimentId);
    }
  });
}


export function activateSuccessTracking() {
  const siteId = getSiteId();

  if (siteId) {
    awaitPriorsLoaded(siteId, () => potentiallyTrackSuccess(siteId));
    window.addEventListener("vcLocationChange", () => {
      awaitPriorsLoaded(siteId, () => potentiallyTrackSuccess(siteId));
    });
  }
}